import React from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";

interface DeleteStudentModalProps {
  studentName: string;
  studentEmail: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteStudentModal: React.FC<DeleteStudentModalProps> = ({
  studentName,
  studentEmail,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="bg-red-500 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-2 rounded-lg">
              <FiAlertTriangle className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-xl font-bold text-white">Delete Student</h2>
          </div>
          <button
            onClick={onCancel}
            className="text-white hover:bg-white/20 p-1 rounded transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <p className="text-gray-700 mb-4">
              Are you sure you want to delete this student? This action cannot
              be undone.
            </p>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <div className="mb-2">
                <span className="text-xs font-semibold text-gray-600 uppercase">
                  Student Name
                </span>
                <p className="text-gray-900 font-medium">{studentName}</p>
              </div>
              <div>
                <span className="text-xs font-semibold text-gray-600 uppercase">
                  Email
                </span>
                <p className="text-gray-900 font-medium">{studentEmail}</p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
            <p className="text-sm text-yellow-800">
              <strong>Warning:</strong> All associated data including
              enrollments, payments, and progress will be permanently deleted.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors font-medium flex items-center gap-2"
          >
            <FiAlertTriangle className="w-4 h-4" />
            Delete Student
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteStudentModal;
